import { isArray, mergeWith } from "lodash-es";

//#region src/shared/utils/merge.ts
function mergeIgnoringArrays(target, ...sources) {
	return mergeWith(target, ...sources, customizer);
}
function customizer(objValue, srcValue) {
	if (isArray(objValue)) return srcValue;
}

//#endregion
export { mergeIgnoringArrays };
//# sourceMappingURL=merge.js.map